import { useMutation } from "@tanstack/react-query";
import useAuth from "../../hooks/useAuth";
import {
  ISD_CODE,
  LOGIN_ENDPOINT,
  LOGIN_PRODUCT_ID,
  LOGIN_TENANT_ID,
  PLATFORM,
  REQUEST_PRODUCT_ID,
  VALID_SALES_ROLE_IDS,
} from "constants/config";

const login = async ({ mobile, password, isd_code = ISD_CODE }) => {
  const response = await fetch(LOGIN_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      platform: PLATFORM,
      "product-id": LOGIN_PRODUCT_ID,
      "tenant-id": LOGIN_TENANT_ID,
    },
    body: JSON.stringify({
      isd_code: isd_code || ISD_CODE,
      phone: mobile,
      password,
      product_id: REQUEST_PRODUCT_ID,
      tenant_id: LOGIN_TENANT_ID,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    const message = data?.message || "Something went wrong please try again.";
    throw new Error(message);
  }

  const receivedData = data && data.data;

  const hasValidRole = receivedData.roles.some((roleId) =>
    Object.keys(VALID_SALES_ROLE_IDS).map(Number).includes(roleId)
  );

  if (!hasValidRole) {
    throw new Error(
      "You do not have the required permissions to access this platform."
    );
  }

  return receivedData;
};

export const useLogin = () => {
  const { login: authLogin } = useAuth();

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      if (data.access_token) {
        if (
          data.roles &&
          data.roles.some((roleId) =>
            Object.keys(VALID_SALES_ROLE_IDS).map(Number).includes(roleId)
          )
        ) {
          authLogin(data.access_token);
        } else {
          throw new Error(
            "User does not have the required permissions to log in."
          );
        }
      } else {
        throw new Error("No access token in response");
      }
    },
    onError: (error) => {
      console.error("Login error:", error.message || "An error occurred");
    },
  });
};
